// extracted by mini-css-extract-plugin
export var container = "_f5-1";
export var cornerButtonContainer = "_f5-6";
export var disabled = "_f5-2";
export var dragActive = "_f5-3";
export var fileContainer = "_f5-5";
export var hiddenInput = "_f5-4";
export var widthContainer = "_f5-0";